import Swal  from 'sweetalert2';
import { ImageService } from '../../_services/image.service';
import { DataUtilService } from '../../_services/data-util.service';
import { StudentService } from '../../_services/student.service';
import { Component, OnInit,Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-student-gift-area',
  templateUrl: './student-gift-area.component.html',
  styleUrls: ['./student-gift-area.component.css']
})
export class StudentGiftAreaComponent implements OnInit {
  @Input() learner:any={}
  @Input() maskedGift:any={}
  server_student_user_id:0
  imageSource:any
  qMax=16;
  isRedeeming=false
  isRedeemed =false
  isRedeemingMessage="Yes, Yes!"
  awardList=[]
  constructor(
    private studentService:StudentService,
    private dataUtilService:DataUtilService,
    private imageService:ImageService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

    if (this.learner.server_student_id != 0) {
      this.server_student_user_id = this.learner.server_user_id
      this.imageService.giftInfo(this.server_student_user_id ).subscribe(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            let myData= this.dataUtilService.myData(x)
            this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${myData}`);
          }

        }
      )

      this.studentService.getStudentAwards(this.server_student_user_id).subscribe(
        x=>{
          this.awardList=x

        }

      )
    }
  }
  doMoreInfo(){
    Swal.fire( 'Hello Well done '+this.learner.fullname+'  Now do and Pass ' +this.qMax +' question to win another gift')
  }
  onClickGiftInfo(){

      var qPassCount= this.qMax - this.maskedGift.giftPassCount
      var qqqq="questions";
      if(qPassCount==1){
      qqqq="question";
      }
      Swal.fire( 'Hello '+this.learner.fullname, qPassCount+" "+qqqq+" remaining to pass and unwrap your gift",'info')

  }
  onClickRedeemGift(){
    this.isRedeeming=true
    if(!this.isRedeemed){
      this.redeemGift()
    }else{
      this.studentService.getGiftingInformation(this.server_student_user_id).subscribe(
        x=>{
          this.maskedGift=x
          this.doMoreInfo()
        }
      )

    }

  }

  sleep (time:number) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  redeemGift(){
    this.imageService.redeemGift(this.server_student_user_id ).subscribe(
      val=>{
        this.sleep(600).then(() => {
          this.isRedeemingMessage="You have"
          this.sleep(600).then(() => {
            this.isRedeemingMessage="You have won!"
            this.sleep(600).then(() => {
              this.isRedeeming=false
              this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${val}`);
              this.isRedeemingMessage=""
              this.isRedeemed=true
            });
          });
       });

      }
    )
  }
}
